import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom, center, buttonStyle } from '../../../helpers/getEmailStyles';

class NewMessage extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      receiverName: PropTypes.string.isRequired,
      userType: PropTypes.string,
      message: PropTypes.string.isRequired,
      threadId: PropTypes.number.isRequired,
    }).isRequired
  };

  render() {
    const { content: { receiverName, type, message, threadId, logo, siteName } } = this.props;
    let messageURL = url + '/message/' + threadId + '/guest';
    if (type === "host") {
      messageURL = url + '/message/' + threadId + '/host';
    }

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Bonjour {receiverName},
          </div>
          <EmptySpace height={20} />
          <div>
            Vous avez reçu un nouveau message sur la plateforme {siteName}
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}>
            Voici les détails du message.
          </div>
          <div style={marginBottom}><span style={fontWeightBold}>Message :</span></div>
          <div>
            {
              message && (message.trim()).split("\n").map(function (item, index) {
                return (
                  <span key={index + 1}>{item}</span>
                )
              })
            }
          </div>
          <EmptySpace height={20} />
          <div>
            Pour répondre à l'expéditeur, cliquez sur le bouton ci-dessous
          </div>
          <EmptySpace height={20} />
          <div style={center}>
            <a href={messageURL} style={buttonStyle}>Répondre à l'expéditeur</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default NewMessage;